import React, { memo } from "react";
import { MenuItem, Select, SelectProps } from "@material-ui/core";
import useAppSelect from "./index.hooks";

type AppSelectProps = {
  options: { value: string; label: string }[];
} & SelectProps;

const AppSelect = ({ options, ...props }: AppSelectProps) => {
  const { styles, classes } = useAppSelect();

  // @TODO: move this className into classes root
  return (
    <Select
      {...props}
      className={styles.selectContainer}
      classes={classes.appSelect}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default memo(AppSelect);
